import * as React from 'react'

import Box from '@mui/material/Box'
import Checkbox from '@mui/material/Checkbox'
import DeleteIcon from '@mui/icons-material/Delete'
import FilterListIcon from '@mui/icons-material/FilterList'
import FormControlLabel from '@mui/material/FormControlLabel'
import IconButton from '@mui/material/IconButton'
import Paper from '@mui/material/Paper'
import PropTypes from 'prop-types'
import Switch from '@mui/material/Switch'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TablePagination from '@mui/material/TablePagination'
import TableRow from '@mui/material/TableRow'
import TableSortLabel from '@mui/material/TableSortLabel'
import Toolbar from '@mui/material/Toolbar'
import Tooltip from '@mui/material/Tooltip'
import Typography from '@mui/material/Typography'
import { alpha } from '@mui/material/styles'
import { visuallyHidden } from '@mui/utils'

// import data from './csvjson.json'

/* To use JSON data from an MLS CSV export, map over array of JSON objects, for each object, trip, lowercase, split where there is a space and join with underscore. Then check if current key is already present, if not then copy the existing unprocessed key element into the new processed key. Then delete the old unprocessed key. */

// data.map(obj => {
//   return Object.keys(obj).forEach(key => {
//     var replacedKey = key.trim().toLowerCase().split(' ').join('_')
//     if (key !== replacedKey) {
//       obj[replacedKey] = obj[key]
//       delete obj[key]
//     }
//   })
// })

// console.log({data})

// const rows = data

function preventDefault(event) {
  event.preventDefault()
}

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1
  }
  if (b[orderBy] > a[orderBy]) {
    return 1
  }
  return 0
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy)
}

// This method is created for cross-browser compatibility, if you don't
// need to support IE11, you can use Array.prototype.sort() directly
function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index])
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0])
    if (order !== 0) {
      return order
    }
    return a[1] - b[1]
  })
  return stabilizedThis.map(el => el[0])
}

// const headCells = [
//   {
//     id: 'index+1',
//     numeric: false,
//     disablePadding: true,
//     label: '#',
//   },
//   {
//     id: 'mls_number',
//     numeric: false,
//     disablePadding: false,
//     label: 'MLS #',
//   },
//   {
//     id: 'status',
//     numeric: false,
//     disablePadding: false,
//     label: 'Status',
//   },
//   {
//     id: 'address',
//     numeric: false,
//     disablePadding: false,
//     label: 'Address',
//   },
//   {
//     id: 'subdiv',
//     numeric: false,
//     disablePadding: false,
//     label: 'Subdivision',
//   },
//   {
//     id: 'list_price',
//     numeric: false,
//     disablePadding: false,
//     label: 'List Price',
//   },
//   {
//     id: 'beds',
//     numeric: false,
//     disablePadding: false,
//     label: 'Beds',
//   },
//   {
//     id: 'fbaths',
//     numeric: false,
//     disablePadding: false,
//     label: 'Full Baths',
//   },
//   {
//     id: 'hbaths',
//     numeric: false,
//     disablePadding: false,
//     label: 'Half Baths',
//   },
//   {
//     id: 'tot_sqft',
//     numeric: false,
//     disablePadding: false,
//     label: 'SqFt',
//   },
//   {
//     id: 'reo',
//     numeric: false,
//     disablePadding: false,
//     label: 'REO',
//   },
//   {
//     id: 'salePrice',
//     numeric: false,
//     disablePadding: false,
//     label: 'Sale Price',
//   },
//   {
//     id: 'days_on_market',
//     numeric: false,
//     disablePadding: false,
//     label: 'Active Days on Market',
//   },
//   {
//     id: 'entry_date',
//     numeric: false,
//     disablePadding: false,
//     label: 'Date Listed',
//   },
// ]

//duplicated the headCells to make changes
const headCells = [
  {
    id: 'index+1',
    numeric: false,
    disablePadding: true,
    label: '#',
  },
  {
    id: 'mls_number',
    numeric: false,
    disablePadding: false,
    label: 'MLS #',
  },
  {
    id: 'status',
    numeric: false,
    disablePadding: false,
    label: 'Status',
  },
  {
    id: 'address',
    numeric: false,
    disablePadding: false,
    label: 'Address',
  },
  {
    id: 'subdiv',
    numeric: false,
    disablePadding: false,
    label: 'Listing Agent',
  },
  {
    id: 'list_price',
    numeric: false,
    disablePadding: false,
    label: 'List Price',
  },
  {
    id: 'beds',
    numeric: false,
    disablePadding: false,
    label: 'Beds',
  },
  {
    id: 'fbaths',
    numeric: false,
    disablePadding: false,
    label: 'Full Baths',
  },
  {
    id: 'hbaths',
    numeric: false,
    disablePadding: false,
    label: 'Half Baths',
  },
  {
    id: 'sqft',
    numeric: false,
    disablePadding: false,
    label: 'SqFt',
  },
  {
    id: 'reo',
    numeric: false,
    disablePadding: false,
    label: 'REO',
  },
  {
    id: 'salePrice',
    numeric: false,
    disablePadding: false,
    label: 'Sale Price',
  },
  {
    id: 'days_on_market',
    numeric: false,
    disablePadding: false,
    label: 'Active Days on Market',
  },
  {
    id: 'entry_date',
    numeric: false,
    disablePadding: false,
    label: 'Date Listed',
  },
]

function EnhancedTableHead(props) {
  const { onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort } = props
  const createSortHandler = property => event => {
    onRequestSort(event, property)
  }

  return (
    <TableHead>
      <TableRow>
        <TableCell padding="checkbox">
          <Checkbox
            color="primary"
            indeterminate={numSelected > 0 && numSelected < rowCount}
            checked={rowCount > 0 && numSelected === rowCount}
            onChange={onSelectAllClick}
            inputProps={{
              'aria-label': 'select all desserts',
            }}
          />
        </TableCell>
        {headCells.map(headCell => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'normal'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  )
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
}

function EnhancedTableToolbar(props) {
  const { numSelected } = props

  return (
    <Toolbar
      sx={{
        pl: { sm: 2 },
        pr: { xs: 1, sm: 1 },
        ...(numSelected > 0 && {
          bgcolor: theme =>
            alpha(theme.palette.primary.main, theme.palette.action.activatedOpacity),
        }),
      }}
    >
      {numSelected > 0 ? (
        <Typography sx={{ flex: '1 1 100%' }} color="inherit" variant="subtitle1" component="div">
          {numSelected} selected
        </Typography>
      ) : (
        <Typography sx={{ flex: '1 1 100%' }} variant="h6" id="tableTitle" component="div">
          Properties List
        </Typography>
      )}

      {numSelected > 0 ? (
        <Tooltip title="Delete">
          <IconButton>
            <DeleteIcon />
          </IconButton>
        </Tooltip>
      ) : (
        <Tooltip title="Filter list">
          <IconButton>
            <FilterListIcon />
          </IconButton>
        </Tooltip>
      )}
    </Toolbar>
  )
}

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
}

export default function EnhancedPropertiesTable({propertiesData}) {
  const [order, setOrder] = React.useState('asc')
  const [orderBy, setOrderBy] = React.useState('calories')
  const [selected, setSelected] = React.useState([])
  const [page, setPage] = React.useState(0)
  const [dense, setDense] = React.useState(false)
  const [rowsPerPage, setRowsPerPage] = React.useState(5)

  // console.log(propertiesData)

  const rows = propertiesData

  // console.log({rows})


  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc'
    setOrder(isAsc ? 'desc' : 'asc')
    setOrderBy(property)
  }

  const handleSelectAllClick = event => {
    if (event.target.checked) {
      const newSelected = rows.map(n => n.name)
      setSelected(newSelected)
      return
    }
    setSelected([])
  }

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name)
    let newSelected = []

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name)
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1))
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1))
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      )
    }

    setSelected(newSelected)
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage)
  }

  const handleChangeRowsPerPage = event => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(0)
  }

  const handleChangeDense = event => {
    setDense(event.target.checked)
  }

  const isSelected = name => selected.indexOf(name) !== -1

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0

  return (
    <Box sx={{ width: '100%' }}>
      <Paper sx={{ width: '100%', mb: 2 }}>
        <EnhancedTableToolbar numSelected={selected.length} />
        <TableContainer>
          <Table
            sx={{ minWidth: 750 }}
            aria-labelledby="tableTitle"
            size={dense ? 'small' : 'medium'}
          >
            <EnhancedTableHead
              numSelected={selected.length}
              order={order}
              orderBy={orderBy}
              onSelectAllClick={handleSelectAllClick}
              onRequestSort={handleRequestSort}
              rowCount={rows.length}
            />
            <TableBody>
              {/* if you don't need to support IE11, you can replace the `stableSort` call with:
                 rows.sort(getComparator(order, orderBy)).slice() */}
              {stableSort(propertiesData, getComparator(order, orderBy))
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => {
                  const isItemSelected = isSelected(row.name)
                  const labelId = `enhanced-table-checkbox-${index}`

                  return (
                    <TableRow
                      hover
                      onClick={event => handleClick(event, row.name)}
                      role="checkbox"
                      aria-checked={isItemSelected}
                      tabIndex={-1}
                      key={index}
                      selected={isItemSelected}
                    >
                      <TableCell padding="checkbox">
                        <Checkbox
                          color="primary"
                          checked={isItemSelected}
                          inputProps={{
                            'aria-labelledby': labelId,
                          }}
                        />
                      </TableCell>
                      <TableCell
                        align="left"
                        component="th"
                        id={labelId}
                        scope="row"
                        padding="none"
                      >
                        {index + 1}
                      </TableCell>
                      <TableCell align="left">{row.mls}</TableCell>
                      <TableCell align="left">{row.status}</TableCell>
                      <TableCell align="left">{row.address}</TableCell>
                      {/* <TableCell align="left">{row.subdiv}</TableCell> */}
                      <TableCell align="left">{row.listingAgent}</TableCell>
                      <TableCell align="left">{row.price}</TableCell>
                      <TableCell align="left">{row.bedrooms}</TableCell>
                      <TableCell align="left">{row.restrooms}</TableCell>
                      <TableCell align="left">{row.hbaths}</TableCell>
                      <TableCell align="left">{row.sqft}</TableCell>
                      <TableCell align="left">{row.reo}</TableCell>
                      <TableCell align="left">{row.soldPrice}</TableCell>
                      <TableCell align="left">{row.days_on_market}</TableCell>
                      <TableCell align="left">{row.entry_date}</TableCell>
                    </TableRow>
                  )
                })}
              {emptyRows > 0 && (
                <TableRow
                  style={{
                    height: (dense ? 33 : 53) * emptyRows,
                  }}
                >
                  <TableCell colSpan={6} />
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={rows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>
      <FormControlLabel
        control={<Switch checked={dense} onChange={handleChangeDense} />}
        label="Dense padding"
      />
    </Box>
  )
}

// export default function ClientTable() {
//   return (
//     <React.Fragment>
//       <Title>My Clients</Title>
//       <Table size="small">
//         <TableHead>
//           <TableRow>
//             <TableCell>Date</TableCell>
//             <TableCell>Name</TableCell>
//             <TableCell>Ship To</TableCell>
//             <TableCell>Payment Method</TableCell>
//             <TableCell align="right">Sale Amount</TableCell>
//           </TableRow>
//         </TableHead>
//         <TableBody>
//           {rows.map(row => (
//             <TableRow key={row.id}>
//               <TableCell>{row.date}</TableCell>
//               <TableCell>{row.name}</TableCell>
//               <TableCell>{row.shipTo}</TableCell>
//               <TableCell>{row.paymentMethod}</TableCell>
//               <TableCell align="right">{`$${row.amount}`}</TableCell>
//             </TableRow>
//           ))}
//         </TableBody>
//       </Table>
//       <Link color="primary" href="#" onClick={preventDefault} sx={{ mt: 3 }}>
//         See more orders
//       </Link>
//     </React.Fragment>
//   )
// }
